module.exports = __webpack_public_path__ + "img/wx_icon_Select.63a3d78d.png";